import moment from "moment";
import { useNavigate } from "react-router-dom";
import APIS from "../../constant/EndPoint";
import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import Button from "../Reusable/Button";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import { useState } from "react";
import { useForm } from "react-hook-form";
import Card from "../Reusable/Card";
import RunsheetFilter from "./RunsheetFilter";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";
const DeliveryList = () => {
  const [isFilterVisible, setFilterVisiable] = useState(false);
  const {
    register,
    setValue,
    getValues,
    watch,
    reset,
    clearErrors,
    formState: { errors },
  } = useForm({});
  const handleFilterReset = () => {
    reset();
    setValue("is_rtv", null);
    setValue("order_remarks__isnull", null);
    setValue("is_walking_customer", null);
    setValue("delivery_status__in", null);
  };
  const navigate = useNavigate();
  const defaultColumns: any = [
    {
      header: "Delivery ID",
      accessorKey: "tracking_number",
      cell: NACell,
    },
    {
      header: "Created",
      accessorKey: "created",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>
              {getValue()
                ? moment(getValue()).format("YY-MM-DD HH:mm:ss")
                : "N/A"}
            </p>
          </>
        );
      },
    },
    {
      header: "Updated",
      accessorKey: "modified",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>
              {getValue()
                ? moment(getValue()).format("YY-MM-DD HH:mm:ss")
                : "N/A"}
            </p>
          </>
        );
      },
    },
    {
      header: "Vehicle",
      accessorKey: "vehicle.license_number",
      cell: NACell,
    },
    {
      header: "Driver",
      accessorKey: "driver.user.full_name",
      cell: NACell,
    },

    {
      header: "Total Items",
      accessorKey: "total_items",
      cell: ({ row, getValue }: any) => {
        return (
          <>
            <p>{getValue() ?? 0.0}</p>
          </>
        );
      },
    },
  ];
  const handleDetailNavigate = (row: any) => {
    navigate(`edit/${row?.original?.id}`);
  };
  const filterParams = watch();
  return (
    <>
      <Card title="Filters" onClick={() => setFilterVisiable(!isFilterVisible)}>
        <RunsheetFilter
          isFilterVisible={isFilterVisible}
          register={register}
          errors={errors}
          setValue={setValue}
          getValues={getValues}
          reset={handleFilterReset}
          watch={watch}
          clearErrors={clearErrors}
        />
      </Card>
      <DataTable
        url={`${APIS.DELIVERY}`}
        queryKey={"delivery"}
        tableName="delivery-table"
        params={{
          ...filterParams,
          type: "delivery",
        }}
        handleDetailNavigate={handleDetailNavigate}
        columns={defaultColumns}
        addNewPagePath={"/runsheet/create"}
        
      />
    </>
  );
};

export default DeliveryList;
